import React from 'react';
import { DollarSign } from 'lucide-react';

export const Thermometer = ({ current, goal, className = '' }) => {
  const percentage = Math.min((current / goal) * 100, 100);
  
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  return (
    <div className={`w-full ${className}`} data-testid="millionaire-thermometer">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <DollarSign className="w-5 h-5 text-orange-600" />
          <span className="font-mono text-xs text-orange-700 uppercase tracking-widest font-semibold">Millionaire Pot</span>
        </div>
        <span className="font-mono text-xs text-orange-700 font-bold">{percentage.toFixed(1)}%</span>
      </div>
      
      <div className="relative h-8 bg-gradient-to-r from-slate-100 to-slate-200 rounded-full overflow-hidden border border-slate-200 shadow-inner">
        <div 
          className="absolute inset-y-0 left-0 bg-gradient-to-r from-orange-500 via-orange-600 to-amber-600 transition-all duration-500 ease-out rounded-full"
          style={{ width: `${percentage}%`, boxShadow: '0 0 20px rgba(234,88,12,0.4)' }}
        />
      </div>
      
      <div className="flex items-center justify-between mt-2">
        <span className="text-xs text-slate-600 font-medium">{formatCurrency(current)}</span>
        <span className="text-xs text-orange-700 font-bold">Goal: {formatCurrency(goal)}</span>
      </div>
    </div>
  );
};
